<template>
  <div class="action-box">
    <el-dialog :title="title" :visible.sync="dialogVisible" width="400px" :before-close="handleClose" :close-on-click-modal="false">
      <el-form ref="form" :model="params" :rules="rules" label-width="100px">
        <el-form-item label="用户ID:" prop="uid">
          <el-input v-model="params.uid"  size="small"></el-input>
        </el-form-item>
        <el-form-item label="留言内容:" prop="content">
          <el-input v-model="params.content" type="textarea" rows="3" size="small"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose" size="small">取 消</el-button>
        <el-button type="primary" @click="sendComment()" :loading="flag" size="small">确 认</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import API from "@/api";

export default {
  data() {
    return {
      dialogVisible: false,
      title: '留言',
      // 提交状态
      flag: false,
      id: '',
      // 回复评论的参数
      params: {
        uid: '',
        content: ''
      },
      // 表单验证规则
      rules: {
        uid: [
          { required: true, message: '请输入用户ID', trigger: 'blur' },
        ],
        content: [
          { required: true, message: '请输入留言内容', trigger: 'blur' },
        ],
      }
    }
  },
  methods: {
    sendComment(){
      const params = this.params
      API.leaveMessage(params)
        .then(res => {
          (res.code === 200 && (
            this.$message.success('留言成功！'),
            this.handleClose(),
            this.$emit('handleList')
          )) || (
            this.$message.error('操作失败，请重试')
          )
        })
        .catch(() => {
          this.$message.error('操作失败，请重试')
        })
        .finally(() => {
          this.params.content = ''
        })
    },
    // 关闭弹窗
    handleClose() {
      this.dialogVisible = false
      this.$refs.form.resetFields()
      this.params = {
        uid: '',
        content: ""
      }
    },
    // 打开编辑视频弹窗、传递需要编辑的参数
    open(data) {
      this.dialogVisible = true
      this.params = {
        uid: data.uid,
        content: data.content || ""
      }
    }
  }
}
</script>